import useIsMounted from '@/hooks/useIsMounted'
import React from 'react'
export const Module = ({ children }: React.PropsWithChildren) => {
  const isHydrated = useIsMounted()
  return isHydrated ? <>{children}</> : <></>
}
